import React, { FunctionComponent } from 'react';

import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { Gender } from 'social/publisher/Publisher.types';

interface Props {
    genders: Gender[] | undefined;
    save: any;
}

const GENDER_OPTIONS = [
    {
        label: 'ALL',
        value: 0,
    },
    {
        label: 'MALE',
        value: Gender.MALE,
    },
    {
        label: 'FEMALE',
        value: Gender.FEMALE,
    },
];

export const GenderField: FunctionComponent<Props> = ({ genders, save }) => {
    const { t } = useTranslation(['social/publisher']);
    const selectedGender = genders && genders.length === 1 ? genders[0] : 0;
    const handleSelectGender = (genderKey: number): void => {
        const newGender = [];

        if (genderKey === Gender.MALE || genderKey === Gender.FEMALE) {
            newGender.push(genderKey);
        }
        save(newGender);
    };

    return (
        <Form.Group>
            {GENDER_OPTIONS.map((el) => (
                <Form.Check
                    type="radio"
                    label={t(el.label)}
                    value={el.value}
                    checked={selectedGender === el.value}
                    onChange={(): void => handleSelectGender(el.value)}
                    key={el.value}
                    id={el.label}
                />
            ))}
        </Form.Group>
    );
};
